import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram, faLinkedin, faTiktok, faYoutube, faSnapchat } from "@fortawesome/free-brands-svg-icons";
import "./Footer.css"; // Import the CSS file
import logo from '../assets/akari-logo.png'

const Footer = () => {
  return (
    <footer>
      {/* Newsletter Subscription Section */}
      <div className="newsletter">
        <div className="newsletter-content">
          <h2>اشترك في النشرة الإخبارية لدينا</h2>
          <p>ابق على اطلاع دائم بسوق العقارات في المملكة العربية السعودية مع أحدث الاتجاهات والرؤى والفرص!</p>
          <div className="newsletter-input">
            <input type="email" placeholder="Email address..." />
            <button>➜</button>
          </div>
        </div>
        <img src={logo} alt="logo-image" className="newsletter-img" />
      </div>

      {/* Footer Content */}
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-section">
          <h3 className="footer-title">🏡 Akari</h3>
          <p>العقارات لا تتعلق فقط بالممتلكات؛ بل تتعلق بالإمكانات والازدهار والأشخاص</p>
          <div className="social-icons">
          <span><a href="https://www.youtube.com/@AKARI.ATEEQOFFICE" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faYoutube} className="icon" />
        </a>
           </span>
           <span><a href="https://www.tiktok.com/@akari.akari11?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTiktok} className="icon" />
        </a>
           </span>
           <span><a href="https://www.snapchat.com/add/akari.ateeq" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faSnapchat} className="icon" />
        </a>
           </span>
            <span><a href="https://www.facebook.com/re.akari.sa?locale=ar_AR" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebook} className="icon" />
        </a>
           </span>
            <span> <a href="https://x.com/re_akari_sa" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTwitter} className="icon" />
        </a></span>
            <span><a href="https://www.instagram.com/re_akari_sa/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} className="icon" />
        </a></span>
            <span><a href="https://www.linkedin.com/in/abdullah-alateeq-630640256/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faLinkedin} className="icon" />
        </a></span>
          </div>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h4 className="footer-title">خدمات</h4>
          <ul className="footer-link">
            <li><a>متجر عقارات</a></li>
            <li><a href="realestatebrokerage">الوساطة العقارية</a></li>
            <li><a href="realestatemarketing">تسويق العقارات</a></li>
            <li>فحص العقارات</li>
            <li><a href="realestateconsulting">الاستشارات العقارية</a></li>
            <li><a href="contractdocumentation">توثيق عقود البيع والشراء</a></li>
            <li>مزادات العقارات</li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4 className="footer-title">روابط سريعة</h4>
          <ul>
            <li><a href='/about'>نبذة عن</a></li>
            <li><a href='/news'>الأخبار</a></li>
            <li><a href='/blog'>مدونة</a></li>
            <li><a href='/intellectualpropertyrights'>حقوق الملكية الفكرية</a></li>
          </ul>
        </div>

        {/* Business Info */}
        <div className="footer-section">
          <h4 className="footer-title">الأعمال</h4>
          <ul>
            <li>النجاح</li>
            <li>مرشد</li>
            <li>البعثة</li>
            <li>الشروط والأحكام</li>
            <li>سياسة الخصوصية</li>
          </ul>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom">
      &copy;2025 <span className="highlight">عقاري</span> | جميع الحقوق محفوظة
      </div>
    </footer>
  );
};

export default Footer;
